/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { WarningAlt32, Bee32 } from '@carbon/icons-react';
import { Link } from 'carbon-addons-iot-react';

const propTypes = {
  isError: PropTypes.bool,
  message: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  linkHref: PropTypes.string,
  linkOnClick: PropTypes.func,
  customLink: PropTypes.node,
  children: PropTypes.node,
  showIcon: PropTypes.bool,
};
const defaultProps = {
  isError: false,
  linkText: undefined,
  linkHref: '#',
  linkOnClick: undefined,
  customLink: undefined,
  children: null,
  showIcon: true,
};

const TableEmptyState = ({
  isError,
  message,
  linkText,
  linkHref,
  linkOnClick,
  customLink,
  children,
  showIcon,
}) => (
  <div className="table-empty-state">
    <div className="table-empty-state--inner">
      {showIcon ? (
        <div className="table-empty-state--inner--icon">
          {isError ? <WarningAlt32 /> : <Bee32 />}
        </div>
      ) : null}
      <p className="table-empty-state--inner--message">{message}</p>
      <div className="table-empty-state--inner--link">
        {customLink ||
          (linkText ? (
            <Link href={linkHref} onClick={linkOnClick} target="_blank">
              {linkText}
            </Link>
          ) : undefined)}
      </div>
      <div className="table-empty-state--inner--children">{children}</div>
    </div>
  </div>
);

TableEmptyState.propTypes = propTypes;
TableEmptyState.defaultProps = defaultProps;
export default TableEmptyState;
